import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Form, Button, Row, Col, Card } from 'react-bootstrap';
import { toast } from 'react-toastify';
import Message from '../components/Message';
import Loader from '../components/Loader';
import FormContainer from '../components/FormContainer';
import { useGetProductDetailsQuery } from '../slices/productsApiSlice';
import { useCreatePreOrderMutation } from '../slices/preOrdersApiSlice';

const CreatePreOrderScreen = () => {
  const { productId } = useParams();
  console.log(productId);
  const navigate = useNavigate();

  const [quantity, setQuantity] = useState(1);
  const [expectedDate, setExpectedDate] = useState('');
  const [depositAmount, setDepositAmount] = useState(0);
  const [customerPhone, setCustomerPhone] = useState('');
  const [notes, setNotes] = useState('');

  const {
    data: product,
    isLoading: loadingProduct,
    error: errorProduct,
  } = useGetProductDetailsQuery(productId);

  const [createPreOrder, { isLoading: loadingCreate }] =
    useCreatePreOrderMutation();

  useEffect(() => {
    if (product) {
      // Set default deposit as 20% of product price
      setDepositAmount((product.price * 0.2 * quantity).toFixed(2));
    }
  }, [product, quantity]);

  const submitHandler = async (e) => {
    e.preventDefault();

    if (!expectedDate) {
      toast.error('Please select expected availability date');
      return;
    }

    try {
      const res = await createPreOrder({
        productId,
        quantity,
        expectedAvailabilityDate: expectedDate,
        depositAmount: parseFloat(depositAmount),
        customerPhone,
        notes,
      }).unwrap();

      toast.success('PreOrden creada satisfactoriamente');
      navigate(`/preorder/${res._id}`);
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  return (
    <>
      <Link to='/' className='btn btn-light my-3'>
        Atras
      </Link>
      <FormContainer>
        <h1>Crear PreOrden</h1>
        {loadingProduct ? (
          <Loader />
        ) : errorProduct ? (
          <Message variant='danger'>
            {errorProduct?.data?.message || errorProduct.error}
          </Message>
        ) : (
          <>
            <Card className='mb-4'>
              <Card.Body>
                <Row>
                  <Col md={4}>
                    <img
                      src={product.image}
                      alt={product.name}
                      className='img-fluid rounded'
                    />
                  </Col>
                  <Col md={8}>
                    <h4>{product.name}</h4>
                    <p className='text-muted'>{product.description}</p>
                    <h5 className='text-primary'>${product.price}</h5>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <Form onSubmit={submitHandler}>
              <Form.Group className='my-2' controlId='quantity'>
                <Form.Label>Cantidad</Form.Label>
                <Form.Control
                  type='number'
                  placeholder='Ingrese la cantidad'
                  value={quantity}
                  min='1'
                  onChange={(e) => setQuantity(Number(e.target.value))}
                ></Form.Control>
              </Form.Group>

              <Form.Group className='my-2' controlId='expectedDate'>
                <Form.Label>Fecha Aproximada *</Form.Label>
                <Form.Control
                  type='date'
                  value={expectedDate}
                  min={new Date().toISOString().split('T')[0]}
                  onChange={(e) => setExpectedDate(e.target.value)}
                  required
                ></Form.Control>
              </Form.Group>

              <Form.Group className='my-2' controlId='depositAmount'>
                <Form.Label>Monto Depositado ($)</Form.Label>
                <Form.Control
                  type='number'
                  placeholder='Ingresar el monto a depositar'
                  value={depositAmount}
                  step='0.01'
                  min='0'
                  onChange={(e) => setDepositAmount(e.target.value)}
                ></Form.Control>
                <Form.Text className='text-muted'>
                  Sugerido: 33% del valor total = $
                  {(product.price * 0.33 * quantity).toFixed(2)}
                </Form.Text>
              </Form.Group>

              <Form.Group className='my-2' controlId='customerPhone'>
                <Form.Label>Número de Teléfono (Optional)</Form.Label>
                <Form.Control
                  type='tel'
                  placeholder='Ingrese el número de teléfono'
                  value={customerPhone}
                  onChange={(e) => setCustomerPhone(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Form.Group className='my-2' controlId='notes'>
                <Form.Label>Notas (*)</Form.Label>
                <Form.Control
                  as='textarea'
                  rows={3}
                  placeholder='Ingrese una nota'
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                ></Form.Control>
              </Form.Group>

              <Button
                disabled={loadingCreate}
                type='submit'
                variant='primary'
                className='mt-2'
              >
                {loadingCreate ? 'Agregando...' : 'Agregar'}
              </Button>
            </Form>
          </>
        )}
      </FormContainer>
    </>
  );
};

export default CreatePreOrderScreen;
